import React from "react";

interface GoogleButtonProps {
    text: string;
    onClick?: () => void;
}

const GoogleButton: React.FC<GoogleButtonProps> = ({
    text,
    onClick,
}) => {
    return (
        <button
            type="button"
            onClick={onClick}
            className="w-full flex items-center justify-center gap-3 border border-[#EEEEEE] rounded-lg h-11 py-7"
        >
            {/* Google Icon */}
            <img
                src="/images/Auth-Pages/google-icon.svg"
                alt="Google"
                className="w-8 h-8 mr-2"
            />

            <span className="text-[20px] font-semibold text-black">
                {text}
            </span>
        </button>
    );
};

export default GoogleButton;